module.exports = __webpack_public_path__ + "img/question-circle-fill.07299c35.svg";